export default "__VITE_ASSET__111fb999__"